// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import WebinarsListGlobal from './components/WebinarsListGlobal';
import CriticsBlock from './components/blocks/CriticsBlock';
import WebinarsListRu from './components/WebinarsListRu';
import PartnersList from './components/partners/PartnersList'

Vue.config.productionTip = false;
Vue.config.devtools = true;
/**
 * Include base components
 */
Vue.component('App', App);

/**
 * Include common components
 */
Vue.component('WebinarsListGlobal', WebinarsListGlobal);
Vue.component('WebinarsListRu', WebinarsListRu);
Vue.component('CriticsBlock', CriticsBlock);
Vue.component('PartnersList', PartnersList);

/**
 * Create app
 */
new Vue({
  el: '#app'
});



// WEBPACK FOOTER //
// ./src/main.js